// @flow
import type { Action } from '../types';

export const setCurrentLocale = (locale: string): Action => ({
  type: 'SET_CURRENT_LOCALE',
  payload: { locale },
});

export const setIntl = intl => ({
  type: 'SET_INTL',
  payload: { intl },
});
